module.exports = __webpack_public_path__ + "img/PlanningSimulation.d6588d4b.png";